import MarketingService from '@/api/services/MarketingService';
import PetTrackingDeviceAddToOrderContext from '@docupet/component-library/src/models/PetTrackingDeviceAddToOrderContext';

export const namespaced = true;

export const state = {
  loading: false,
  productInterrupt: null,
  petTrackingDeviceAddToOrderContext: new PetTrackingDeviceAddToOrderContext({}),
  marketingPrice: '',
};

export const mutations = {
  LOADING(state, loading) {
    state.loading = loading;
  },
  SET_PRODUCT_INTERRUPT(state, data) {
    state.productInterrupt = data;
  },
  SET_PET_TRACKING_DEVICE_ADD_TO_ORDER_CONTEXT(state, data) {
    state.petTrackingDeviceAddToOrderContext = data;
  },
  SET_MARKETING_PRICE(state, data) {
    state.marketingPrice = data;
  },
  SET_ADD_TO_ORDER_SECTION_CONTEXT(state, data) {
    state.addToOrderSectionContext = data;
  },
};

export const actions = {
  determineProductInterrupt({ commit }) {
    commit('LOADING', true);
    return new Promise((resolve, reject) => {
      MarketingService.getPetTrackingDeviceLicensingFlowInterruptContext()
        .then((response) => {
          commit('LOADING', false);
          commit('SET_PRODUCT_INTERRUPT', response.productInterrupt);
          commit('SET_ADD_TO_ORDER_SECTION_CONTEXT', response.addToOrderSectionContext);
          commit(
            'SET_PET_TRACKING_DEVICE_ADD_TO_ORDER_CONTEXT',
            new PetTrackingDeviceAddToOrderContext({ ...response.petTrackingDeviceAddToOrderContext })
          );
          commit('SET_MARKETING_PRICE', response.marketingPrice);
          resolve(response);
        })
        .catch((error) => {
          commit('LOADING', false);
          commit('SET_PRODUCT_INTERRUPT', false);
          error.location = 'determineProductInterrupt';
          reject(error);
        })
        .finally(() => {
          commit('LOADING', false);
        });
    });
  },
};

export const getters = {};
